import { FadeIn } from "@/components/motion";

export function FounderSection() {
    return (
        <section id="founder" className="w-full">
            <FadeIn viewport>
                <div className="mx-auto">
                    <img
                        src="/ceo_message.png"
                        alt="Message from the founder"
                        className="h-auto w-full object-cover"
                        loading="lazy"
                    />
                </div>
            </FadeIn>
        </section>
        // <section id="founder" className="bg-slate-50 px-4 py-24 sm:px-6 lg:px-8">
        //     <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:items-center">
        //         <div className="space-y-6 rounded-[2.5rem] border border-slate-200 bg-white p-10 shadow-xl">
        //             <div className="space-y-2">
        //                 <p className="text-sm font-semibold uppercase tracking-[0.4em] text-[#3e5feb]">
        //                     Founder of AI Expert Network
        //                 </p>
        //                 <h2 className="text-3xl font-extrabold text-slate-900">Hey, I&apos;m Mark 👋</h2>
        //             </div>
        //             <blockquote className="border-l-4 border-[#3d5deb] pl-6 text-lg font-semibold text-slate-800">
        //                 “I started this community because I was frustrated with the current state of finding reliable AI
        //                 talent.”
        //             </blockquote>
        //             <p className="text-base leading-relaxed text-slate-600">
        //                 Too many “experts” with no real credentials, too many projects falling through, and too much time
        //                 wasted on endless screening. I&apos;ve been in AI consulting long enough to see the gaps — businesses
        //                 struggling to find genuine expertise, and talented practitioners who can&apos;t break through the noise.
        //             </p>
        //             <div className="rounded-2xl bg-[#c1d8ff] p-6 text-slate-900">
        //                 <p className="text-lg font-semibold text-[#3e5feb]">My mission is simple:</p>
        //                 <p className="mt-3 text-base leading-relaxed">
        //                     Help as many people as possible make their first AI dollar by connecting them with the training and
        //                     vetted community they need to succeed. Whether you&apos;re a business seeking proven expertise or a
        //                     practitioner building your reputation — this is your place.
        //                 </p>
        //             </div>
        //             <div className="flex items-center gap-4">
        //                 <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#2b42a3]/10 font-bold text-[#2b42a3]">
        //                     MK
        //                 </div>
        //                 <div>
        //                     <p className="font-semibold text-slate-900">Mark Kashef</p>
        //                     <p className="text-sm text-[#4669ed]">Founder & CEO</p>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="relative flex justify-center">
        //             <div className="absolute inset-6 rounded-[2.5rem] border-8 border-slate-900" />
        //             <div className="relative rounded-[2.5rem] bg-[#e9f1fe] p-6">
        //                 <img
        //                     src="/mark-founder.jpg"
        //                     alt="Mark Kashef smiling"
        //                     className="h-full w-full rounded-[1.8rem] object-cover"
        //                     loading="lazy"
        //                 />
        //             </div>
        //         </div>
        //     </div>
        // </section>
    )
}

